// src/pages/public/PrivacyPolicy.jsx
import React from "react";
import LogoResized from "../../themes/LogoResized";
import '../../css/privacypolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-logo">
        <LogoResized width={250} height={180} />
      </div>

      <h1>Privacy Policy</h1>
      <p className="effective-date">Effective Date: January 13, 2026</p>

      <p>
        Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use ServSpace AI.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We may collect personal information such as your name, email address, profile details, and other information provided when using our platform. This includes information for both freelancers and businesses to help our AI provider (Claude by Anthropic) provide better matches and recommendations.
      </p>
      <p>
        We also collect non-personal information, including browser type, device type, usage patterns, and other analytics data to improve our services.
      </p>

      <h2>How We Use Your Information</h2>
      <p>
        Your information is used to provide and improve our services, personalize recommendations, communicate with you, and match professionals using our AI assistant. We do not sell your personal information to third parties.
      </p>

      <h2>AI-Assisted Services</h2>
      <p>
        ServSpace AI uses Claude (Anthropic) to assist in matching users with freelancers or businesses. While we strive for accuracy, AI may make mistakes, and recommendations are for informational purposes only.
      </p>

      <h2>Cookies</h2>
      <p>
        Our website uses cookies to enhance your experience and understand usage patterns. You can disable cookies in your browser settings, but some features may not function properly.
      </p>

      <h2>Third-Party Services</h2>
      <p>
        We may use third-party services, such as Google Analytics, Maps API, and payment processors. These services have their own privacy policies, and we encourage you to review them.
      </p>

      <h2>Security</h2>
      <p>
        We implement reasonable measures to protect your information from unauthorized access, disclosure, or alteration. However, no method of transmission over the internet is completely secure.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:info@servspaceai.com">admin@servspaceai.com</a>. We plan to set up a dedicated privacy email for inquiries.
      </p>
    </div>
  );
};

export default PrivacyPolicy;